<template>
  <div>
    <!-- alerta -->
    <Alert
      :alert="alert"
      :type="alertType"
      :title="alertTitle"
      :message="alertMessage"
    />

    <v-row justify="center">
      <v-col cols="12" sm="10" lg="8">
        <v-card outlined elevation="2">
          <v-card-title class="justify-center">
            <p class="text-h4 font-weight-bold primary--text mt-2">Reportes</p>
          </v-card-title>

          <v-card-text>
            <v-row justify="center">
              <v-col cols="4">
                <v-select
                  dense
                  outlined
                  label="Competencia*"
                  :items="competencias"
                  item-value="id"
                  item-text="competencia"
                  v-model="competencia"
                  return-object
                  :rules="competenciaReglas"
                  @change="actualizarDatosHabilidad"
                >
                </v-select>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Habilidad"
                  :items="habilidadesCompetencia"
                  item-value="categoria_id"
                  item-text="categoria"
                  v-model="habilidad"
                >
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Regional"
                  :items="regionales"
                  item-value="id"
                  item-text="regional"
                  v-model="regional"
                  @change="actualizarDatosRegional"
                >
                </v-autocomplete>
                <v-autocomplete
                  dense
                  outlined
                  clearable
                  label="Centro de formación"
                  :items="centrosFormacion"
                  item-value="id"
                  item-text="centro_formacion"
                  v-model="centroFormacion"
                >
                </v-autocomplete>

                <v-checkbox
                  label="Seleccionar Todo"
                  v-model="seleccion"
                  @click="seleccionarTodo"
                >
                </v-checkbox>

                <v-checkbox
                  label="Participantes"
                  value="participante"
                  v-model="worldskills"
                >
                </v-checkbox>

                <v-checkbox
                  label="Ganadores"
                  value="ganador"
                  v-model="worldskills"
                >
                </v-checkbox>

                <v-checkbox
                  label="Enlaces Regionales"
                  value="enlaceRegional"
                  v-model="worldskills"
                >
                </v-checkbox>

                <v-checkbox
                  label="Expertos Regionales"
                  value="expertoRegional"
                  v-model="worldskills"
                >
                </v-checkbox>

                <v-checkbox
                  label="Acompañantes"
                  value="acompanante"
                  v-model="worldskills"
                >
                </v-checkbox>

                <v-checkbox
                  label="Expertos Nacionales"
                  value="expertoNacional"
                  v-model="worldskills"
                >
                </v-checkbox>

                <v-btn
                  large
                  block
                  exact
                  elevation="2"
                  color="primary"
                  class="mt-2 mb-6"
                  @click="reporteWorldSkills"
                >
                  Descargar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Alert from "../../../components/admin/Alert.vue";
export default {
  data: () => ({
    alert: false,
    alertType: "",
    alertTitle: "",
    alertMessage: "",

    seleccion: false,
    competencia: null,
    competenciaReglas: [(v) => !!v || "Seleccione una competencia"],
    habilidad: null,
    regional: null,
    centroFormacion: null,

    worldskills: [],
  }),
  components: {
    Alert,
  },

  mounted() {
    this.$store.dispatch("gestionarCompetenciasWorldSkills");
    this.$store.dispatch("crearRegionales");
    this.$store.dispatch("crearCentrosFormacion");
  },

  computed: {
    competencias() {
      return this.$store.getters.obtenerCompetenciasWorldSkills.filter(
        (competencia) =>
          competencia.tipo_competencia_id == 2 ||
          competencia.tipo_competencia_id == 3 ||
          competencia.tipo_competencia_id == 4,
      );
    },
    habilidadesCompetencia() {
      return this.$store.getters.obtenerHabilidadesCompetencia;
    },

    regionales() {
      return this.$store.getters.obtenerRegionales;
    },
    centrosFormacion() {
      return this.$store.getters.obtenerCentrosFormacionReporte(this.regional);
    },
  },

  methods: {
    actualizarDatosHabilidad() {
      this.$store.dispatch("gestionarHabilidadesCompetencia", this.competencia.id);
    },
    actualizarDatosRegional() {
      this.$store.dispatch("crearCentrosFormacion");
    },
    seleccionarTodo() {
      if (this.seleccion == true) {
        this.worldskills.push(
          "participante",
          "ganador",
          "enlaceRegional",
          "expertoRegional",
          "acompanante",
          "expertoNacional",
        );
      } else {
        this.worldskills.splice(0);
      }
    },

    reporteWorldSkills() {
      if (this.competencia) {
        if (this.worldskills.length > 0) {
          const reporte = {
            competencia: this.competencia.id,
            categoria: this.habilidad,
            regional: this.regional,
            centro_formacion: this.centroFormacion,
            datos: this.worldskills,
          };

          this.$store.dispatch("reporteWorldSkills", reporte)
            .then((response) => {
              const urlReporte = window.URL.createObjectURL(new Blob([response]))
              const link = document.createElement("a")
              link.href= urlReporte
              link.setAttribute("download", `${this.competencia.competencia}.xlsx`)
              document.body.appendChild(link)
              link.click();
              this.worldskills = [];
              this.seleccion = false;
              this.alertTitle = "Descargado";
              this.alertMessage = "Reporte con éxito";
              this.alertType = "success--text";
              this.alert = true;

              setTimeout(() => {
                this.alert = false;
              }, 1000);
            })
            .catch(() => {});
        } else {
          this.alertTitle = "Error";
          this.alertType = "error--text";
          this.alertMessage = "Seleccione items para descargar";
          this.titleCard = "error--text";
          this.alert = true;
        }
      } else {
        this.alertTitle = "Error";
        this.alertType = "error--text";
        this.alertMessage = "Seleccione una competencia";
        this.titleCard = "error--text";
        this.alert = true;
      }
      setTimeout(() => {
        this.alert = false;
      }, 2000);
    },
  },
};
</script>
